<tr *ngIf="!isLoading" class="table-item" (click)="rowClicked.emit()">
  <td>
    <span
      *ngIf="(expiryTooltip$ | async) && !(scheduledTooltip$ | async)"
      [ngbPopover]="expiryTemplate"
      triggers="mouseenter:mouseleave"
      popoverClass="popper-badge">
      <img [src]="'assets/icons/yellow/Clock.svg'" alt="clock" i18n-alt />
    </span>
    <span
      *ngIf="scheduledTooltip$ | async"
      [ngbPopover]="scheduledTemplate"
      triggers="mouseenter:mouseleave"
      popoverClass="popper-badge">
      <img [src]="'assets/icons/primary/Calendar.svg'" alt="calendar" i18n-alt />
    </span>
  </td>
  <td>{{ unit?.unitName }}</td>
  <td>{{ unit?.clientUnitId }}</td>
  <td>{{ unit?.designatedUnitType?.name }}</td>
</tr>

<ng-container *ngIf="isLoading">
  <tr class="table-item">
    <td>
      <lib-loading-shimmer />
    </td>
    <td>
      <lib-loading-shimmer />
    </td>
    <td>
      <lib-loading-shimmer />
    </td>
    <td>
      <lib-loading-shimmer />
    </td>
  </tr>
</ng-container>

<ng-template #expiryTemplate>
  <div class="popover-template">
    <span class="title" i18n>Expiry Set</span>
    <span>{{ expiryTooltip$ | async }}</span>
  </div>
</ng-template>

<ng-template #scheduledTemplate>
  <div class="popover-template">
    <span class="title" i18n>Scheduled</span>
    <span>{{ scheduledTooltip$ | async }}</span>
  </div>
</ng-template>
